import type { AppErrorCode } from "./errors";

export const APP_ERROR_DIAGNOSTICS = {
	BAD_REQUEST: "app.bad_request",
	UNAUTHORIZED: "app.unauthorized",
	FORBIDDEN: "app.forbidden",
	NOT_FOUND: "app.not_found",
	CONFLICT: "app.conflict",
	VALIDATION: "app.validation",
	INTERNAL: "app.internal"
} as const satisfies Record<AppErrorCode, string>;

export const DIAGNOSTIC_CODES = [
	...Object.values(APP_ERROR_DIAGNOSTICS),
	"comment.parent_not_found",
	"comment.reply_depth",
	"comment.not_found",
	"comment.owner_required",
	"onboarding.account_not_provisioned",
	"ids.invalid_issue",
	"lth_buy_box.county_not_found"
] as const;

export type DiagnosticCode = (typeof DIAGNOSTIC_CODES)[number];

export function getDiagnosticCode(code: AppErrorCode, diagnosticCode?: unknown): DiagnosticCode {
	return (
		DIAGNOSTIC_CODES.find((candidate) => candidate === diagnosticCode) ??
		APP_ERROR_DIAGNOSTICS[code]
	);
}
